import React from 'react';
import type { ConditionalBlock as ConditionalBlockType } from '../../../types';
import BlockRenderer from '../BlockRenderer';

type Props = {
    block: ConditionalBlockType;
    depth: number;
};

const ConditionalBlock: React.FC<Props> = ({ block, depth }) => {
    const condition =
        block.operator === 'exists'
            ? `IF {{${block.variable}}} exists`
            : `IF {{${block.variable}}} ${block.operator} "${block.value || ''}"`;

    return (
        <div style={{ margin: '0.8rem 0' }}>
            <div
                style={{
                    border: '1px dashed #6c757d',
                    borderRadius: '0.4rem',
                    overflow: 'hidden'
                }}
            >
                <div
                    style={{
                        padding: '0.4rem 0.8rem',
                        backgroundColor: '#f8f9fa',
                        borderBottom: '1px dashed #6c757d',
                        fontSize: '0.85em',
                        fontFamily: 'monospace',
                        color: '#6c757d'
                    }}
                >
                    {condition}
                </div>
                <div style={{ padding: '0.8rem' }}>
                    <BlockRenderer blocks={block.children} depth={depth + 1} />
                </div>
            </div>
            {block.else_children && block.else_children.length > 0 && (
                <div
                    style={{
                        border: '1px dashed #6c757d',
                        borderRadius: '0.4rem',
                        overflow: 'hidden',
                        marginTop: '0.4rem'
                    }}
                >
                    <div
                        style={{
                            padding: '0.4rem 0.8rem',
                            backgroundColor: '#f8f9fa',
                            borderBottom: '1px dashed #6c757d',
                            fontSize: '0.85em',
                            fontFamily: 'monospace',
                            color: '#6c757d'
                        }}
                    >
                        OTHERWISE
                    </div>
                    <div style={{ padding: '0.8rem' }}>
                        <BlockRenderer blocks={block.else_children} depth={depth + 1} />
                    </div>
                </div>
            )}
        </div>
    );
};
export default ConditionalBlock;
